"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isAuthenticated;

var _utils = require("./utils");

/**
 * A helper function to determine if the current user is authenticated.
 * This function accepts an object argument with a `context` key.
 *
 * This returns true when the LP Auth Api cookie exists and contains a
 * token.
 * If the `context` key is present, this function returns true if the user is
 * both authenticated and the specified context is present.
 * 
 * Note, this does not **validate** the token, it only checks for
 * presence, validation must be done on the server.
 * 
 * @param {Object} [options={}] - config object containing the context
 * @returns {Boolean}
 * @example
 * 
 * // WITHOUT context
 * 
 * // After sign in
 * isAuthenticated() // true
 * 
 * // After sign out
 * isAuthenticated() // false
 * 
 * // WITH context
 * 
 * // After an 'admin' signs in
 * isAuthenticated({ context: 'admin' }) // true
 * 
 * isAuthenticated({ context: 'non-admin' }) // false
 * 
 * // After sign out
 * isAuthenticated({ context: 'admin' }) // false
 * 
 * isAuthenticated({ context: 'non-admin' }) // false
 */
function isAuthenticated() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var context = options.context;
  var lpAuthCookie = (0, _utils.getLpAuthCookie)();
  if (!lpAuthCookie) return false;
  if (context !== undefined) return isAuthenticatedWithContext(lpAuthCookie, context);
  var lpAuthToken = getToken(lpAuthCookie);
  return !!lpAuthToken;
}

function getToken(cookie) {
  var cookieObj = (0, _utils.parseObject)(cookie);
  return cookieObj ? cookieObj.token : cookie;
}

function isAuthenticatedWithContext(cookie, context) {
  var cookieObj = (0, _utils.parseObject)(cookie);
  if (!cookieObj) return false;
  return cookieObj.token && cookieObj.context === context;
}